module.exports = __webpack_public_path__ + "static/media/Stellar Neo Queen Headboard - 155 cm_Light Beige.a63790ce.png";